import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { TabComponent } from '@lib/components';
import { Airport, ApiCommonRequest, LoginStatusType, ValidationErrorInfo } from '@lib/interfaces';
import {
  AswMasterService,
  CommonLibService,
  GetBasicReservationInformationStoreService,
  SystemDateService,
} from '@lib/services';
import { SupportComponent } from '@lib/components/support-class';
import { OnewayOrMultiCityComponent } from '../sub-components/oneway-or-multicity/oneway-or-multicity.component';
import { RoundtripComponent } from '../sub-components/roundtrip/roundtrip.component';
import { SearchFlightConditionForRequestService, SearchFlightStoreService, LocalDateService } from '@common/services';
import { SearchFlightState, TripType } from '@common/store';
import { SearchFlightBodyPresProps } from './search-flight-body-pres.state';
import { GetBasicReservationInformationRequest } from 'src/sdk-amcmember';
import { SearchFlightHistorySelectModalService } from '../../search-flight-history-select/search-flight-history-select-modal.service';
import { SearchFlightBodyContComponent } from '@common/components/shopping/search-flight/search-flight-body/container/search-flight-body-cont.component';
import { ShoppingLibService } from '@common/services/shopping/shopping-lib/shopping-lib.service';
@Component({
  selector: 'asw-search-flight-body-pres',
  templateUrl: './search-flight-body-pres.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFlightBodyPresComponent extends SupportComponent {
  /** 親から渡されるプロパティ */
  @Input()
  public props!: SearchFlightBodyPresProps;
  /** 選択中のタブ番号 */
  // FIXME:暫定対応 タブ切り替え時に画面が固まる事象への対応
  private _tabIndex = 0;
  get tabIndex(): number {
    return this._tabIndex;
  }
  @Input()
  set tabIndex(newValue: number) {
    const oldValue = this._tabIndex;
    if (oldValue !== newValue) {
      this._tabIndex = newValue;
      this._changeDetectorRef.markForCheck();
    }
  }

  private _searchFlightState!: SearchFlightState;
  /** 履歴の表示状態 */
  @Input()
  public isOpenHistory: boolean;
  /** 国際判断フラグ */
  @Input()
  public isJapanOnlyFlag: boolean = false;
  /** お気に入りの表示状態 */
  @Input()
  public isOpenFavorite: boolean;

  @Input()
  public information: {
    departureOriginLocationCode: string | ValidationErrorInfo;
    departureDestinationLocationCode: string | ValidationErrorInfo;
    passengersErrorMsg: string | ValidationErrorInfo;
    originBoundErrorMsg: string | ValidationErrorInfo;
  } = {
    //往復
    departureOriginLocationCode: '',
    departureDestinationLocationCode: '',
    //エラーメッセージ用
    passengersErrorMsg: '',
    originBoundErrorMsg: '',
  };
  @Output()
  changeOptionOpenEvent = new EventEmitter<boolean>();

  @Input() requestParam: any;
  @Input() onewayInformationList: Array<number> = [];
  /** タブ番号 */
  @Output()
  activeNum$ = new EventEmitter<number>();

  // FIXME:暫定対応 タブ切り替え時に画面が固まる事象への対応
  private _activeNum = 0;
  public get activeNum(): number {
    return this._activeNum;
  }
  public set activeNum(newValue: number) {
    const oldValue = this._activeNum;
    if (oldValue !== newValue) {
      this._activeNum = newValue;
      this.activeNum$.emit(newValue);
    }
  }

  /** 空港選択部品押下時出力 */
  @Output()
  changeAirport = new EventEmitter<Airport>();
  /** 特典切り替えリンク押下時出力 */
  @Output()
  awardFlight = new EventEmitter<Event>();

  /** 出発日選択部品押下時出力 */
  @Output()
  changeDepartureDate = new EventEmitter<Date[]>();
  /** DCS移行開始日前後状態 */
  @Input()
  dcsMigrationDateStatus: string = '';
  /** 旧国内ASW取扱検索条件フラグ */
  @Input()
  oldDomesticAswSearchFlag: boolean = false;

  /** 子コンポーネントの参照 */
  @ViewChild('tabComponent') tabComponent!: TabComponent;
  @ViewChild('roundTripComponent') roundTripComponent!: RoundtripComponent;
  @ViewChild('onewayOrMulticityComponent') onewayOrMulticityComponent!: OnewayOrMultiCityComponent;

  /** 特典切り替えリンク表示非表示 */
  public isAwardBookingFlag: boolean = false;

  /** 自動検索要否 */
  @Input()
  public autoSearch: boolean = false;

  constructor(
    private common: CommonLibService,
    private _getBasicReservationInformationService: GetBasicReservationInformationStoreService,
    private _searchFlightStoreService: SearchFlightStoreService,
    private _searchFlightHistorySelectModalService: SearchFlightHistorySelectModalService,
    private _systemDateSvc: SystemDateService,
    private _aswMasterSvc: AswMasterService,
    private _shoppingLibService: ShoppingLibService,
    private _searchFlightConditionForRequestService: SearchFlightConditionForRequestService,
    private _searchFlightBodyContComponent: SearchFlightBodyContComponent,
    private _localDateService: LocalDateService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    super(common);
    this.isOpenHistory = false;
    this.isOpenFavorite = false;
    // 流入データ
    this.subscribeService('SearchFlightStoreService-getData', this._searchFlightStoreService.searchFlight$, (data) => {
      this._searchFlightState = data;
    });
  }

  reload(): void {}
  init(): void {
    const officeCode = this.common.aswContextStoreService.aswContextData.pointOfSaleId;
    const isViaGoshokaiNet = this.common.aswContextStoreService.aswContextData.isViaGoshokaiNet;
    const anaBizLoginStatus = this.common.aswContextStoreService.aswContextData.anaBizLoginStatus;
    if (officeCode !== 'TYONH08AP' && !isViaGoshokaiNet && anaBizLoginStatus !== 'LOGIN') {
      this.isAwardBookingFlag = true;
    }
    // 自動検索以外の場合
    if (!this.autoSearch) {
      // 予約基本情報取得レスポンスの値で出発地と到着地を設定する
      this.departureAndArrivalHandler();
    }
    if (this.common.aswContextStoreService.aswContextData.loginStatus != LoginStatusType.NOT_LOGIN) {
      this._searchFlightHistorySelectModalService.requestHistoryFavoriteGet();
    }
  }
  destroy(): void {}

  /** 旅程種別タブ押下時処理 */
  clickTabEvent(activeNum: number) {
    // FIXME:暫定対応 タブ切り替え時に画面が固まる事象への対応
    this.activeNum = activeNum;
  }

  /** roundtripComponentのストップオーバー入力切替リンク押下時処理 */
  clickStopOverEvent() {
    this.tabComponent.tabClick(1);
    // FIXME:暫定対応 タブ切り替え時に画面が固まる事象への対応
    this.activeNum = this.tabComponent.activeNum;
  }

  /** 出発地・到着地・乗継地値変更時処理 */
  changeAirportEvent(airport: Airport) {
    this.changeAirport.emit(airport);
  }

  /** 出発地・到着地・乗継地値変更時処理 */
  changeDepartureDateEvent(date: Date[]) {
    this.changeDepartureDate.emit(date);
  }

  /** 特典切り替えリンク押下時処理 */
  clickAwardFlight(event: Event) {
    this.awardFlight.emit(event);
  }

  changeOptionOpen(event: boolean) {
    this.changeOptionOpenEvent.emit(event);
  }

  /** 空判定 */
  private isEmpty(value: String): boolean {
    return !value;
  }

  /**予約基本情報取得APIを呼び出す。 */
  private departureAndArrivalHandler() {
    if (this.common.aswContextStoreService.aswContextData.loginStatus !== 'NOT_LOGIN') {
      // 予約基本情報取得APIリクエストパラメータ作成
      const requestParameter: GetBasicReservationInformationRequest & ApiCommonRequest = {
        commonIgnoreErrorFlg: true,
      };
      // 6.1.1 パラメータなしで予約基本情報取得API呼び出し
      this._getBasicReservationInformationService.setGetBasicReservationInformationFromApi(requestParameter);
      // 予約基本情報取得APIレスポンス処理
      this.subscribeService(
        'paymentInputContComponent_getBasicReservationInformation',
        this._getBasicReservationInformationService.getGetBasicReservationInformation$(),
        (responseBasic) => {
          if (!responseBasic.isPending) {
            this.deleteSubscription('paymentInputContComponent_getBasicReservationInformation');
            if (!responseBasic.isFailure) {
              if (responseBasic.data) {
                if (this.isDisplayAgain()) {
                  return;
                }
                const requestParam = this.requestParam ?? {};
                let defaultAdditionalDaysToNextBound: number = parseInt(
                  this._aswMasterSvc.getMPropertyByKey('search', 'defaultAdditionalDaysToNextBound')
                );
                if (this._searchFlightState.tripType === TripType.ROUND_TRIP) {
                  let departureDateRoundTrip: Date | null = this._localDateService.getCurrentDate();
                  let returnDateRoundTrip: Date | null = this._localDateService.getCurrentDate();
                  //リクエストパラメータ.往路出発日が存在しない、またはそのパラメータがyyyy-MM-dd形式の文字列として日付変換できない場合
                  //予約基本情報取得レスポンス.予約日付区分の値に沿って、保持している検索条件.往復旅程区間.往路出発日を設定する
                  //更にリクエストパラメータ.複路出発日が存在しないまたはパラメータがyyyy-MM-dd形式の文字列として日付変換できない場合
                  //予約基本情報取得レスポンス.予約日付区分の値に沿って、保持している検索条件.往復旅程区間.複路出発日を設定する
                  if (
                    this.isEmpty(requestParam['departureDate'] as string) ||
                    !this._searchFlightBodyContComponent.judgeStringDate(requestParam['departureDate'] as string)
                  ) {
                    const returnDateIsEmpty =
                      this.isEmpty(requestParam['returnDate'] as string) ||
                      !this._searchFlightBodyContComponent.judgeStringDate(requestParam['returnDate'] as string);

                    switch (responseBasic.data?.reservationDateDivision) {
                      case '00':
                        departureDateRoundTrip.setDate(departureDateRoundTrip.getDate());
                        if (returnDateIsEmpty) {
                          returnDateRoundTrip.setDate(returnDateRoundTrip.getDate() + defaultAdditionalDaysToNextBound);
                        } else {
                          returnDateRoundTrip = this._searchFlightState.roundTrip.returnDate;
                        }
                        break;
                      case '01':
                        departureDateRoundTrip.setDate(departureDateRoundTrip.getDate() + 1);
                        if (returnDateIsEmpty) {
                          returnDateRoundTrip.setDate(
                            returnDateRoundTrip.getDate() + 1 + defaultAdditionalDaysToNextBound
                          );
                        } else {
                          returnDateRoundTrip = this._searchFlightState.roundTrip.returnDate;
                        }
                        break;
                      case '07':
                        departureDateRoundTrip.setDate(departureDateRoundTrip.getDate() + 7);
                        if (returnDateIsEmpty) {
                          returnDateRoundTrip.setDate(
                            returnDateRoundTrip.getDate() + 7 + defaultAdditionalDaysToNextBound
                          );
                        } else {
                          returnDateRoundTrip = this._searchFlightState.roundTrip.returnDate;
                        }
                        break;
                      case '62':
                        departureDateRoundTrip.setMonth(departureDateRoundTrip.getMonth() + 2);
                        if (returnDateIsEmpty) {
                          returnDateRoundTrip.setMonth(returnDateRoundTrip.getMonth() + 2);
                          returnDateRoundTrip.setDate(returnDateRoundTrip.getDate() + defaultAdditionalDaysToNextBound);
                        } else {
                          returnDateRoundTrip = this._searchFlightState.roundTrip.returnDate;
                        }
                        break;

                      default:
                        departureDateRoundTrip = this._searchFlightState.roundTrip.departureDate;
                        returnDateRoundTrip = this._searchFlightState.roundTrip.returnDate;
                        break;
                    }
                  } else {
                    departureDateRoundTrip = this._searchFlightState.roundTrip.departureDate;
                    returnDateRoundTrip = this._searchFlightState.roundTrip.returnDate;
                  }
                  const airportListKey = this._shoppingLibService.getAirportListKey();
                  // 出発地空港リスト
                  this.departureAirportList = this.isNotEmpty(airportListKey.departureAirportListKey)
                    ? this._aswMasterSvc.aswMaster[airportListKey.departureAirportListKey]
                    : undefined;
                  //到着地空港リスト
                  this.destinationAirportList = this.isNotEmpty(airportListKey.destinationAirportListKey)
                    ? this._aswMasterSvc.aswMaster[airportListKey.destinationAirportListKey]
                    : undefined;
                  const departureOriginLocationCode =
                    this._searchFlightState.roundTrip.departureOriginLocationCode ||
                    responseBasic.data?.departureLocationCode ||
                    null;
                  // 出発地
                  const departureOriginIata = this.getForSearchAirportCode(
                    responseBasic.data?.departureLocationCode!,
                    'origin'
                  );
                  const departureDestinationLocationCode =
                    this._searchFlightState.roundTrip.departureDestinationLocationCode ||
                    responseBasic.data?.arrivalLocationCode ||
                    null;
                  // 到着地
                  const destinationIata = this.getForSearchAirportCode(
                    responseBasic.data?.arrivalLocationCode!,
                    'destination'
                  );
                  const roundtripState: SearchFlightState = {
                    ...this._searchFlightState,
                    roundTrip: {
                      ...this._searchFlightState.roundTrip,
                      departureOriginLocationCode: departureOriginIata,
                      departureDestinationLocationCode: destinationIata,
                      returnOriginLocationCode: destinationIata,
                      returnDestinationLocationCode: departureOriginIata,
                      departureDate: departureDateRoundTrip || null,
                      returnDate: returnDateRoundTrip || null,
                    },
                  };
                  this._searchFlightStoreService.updateStore(roundtripState);
                }
                if (this._searchFlightState.tripType === TripType.ONEWAY_OR_MULTI_CITY) {
                  let departureDate1: Date | null = this._localDateService.getCurrentDate();
                  let departureDate2: Date | null = this._localDateService.getCurrentDate();
                  //リクエストパラメータの”departureDate1”が存在しない、またはそのパラメータがyyyy-MM-dd形式の文字列として日付変換できない場合
                  //予約基本情報取得レスポンス.予約日付区分の値に沿って、保持している検索条件.複雑旅程区間[0].出発日を設定する
                  //更に//リクエストパラメータの”departureDate2”が存在しない、またはそのパラメータがyyyy-MM-dd形式の文字列として日付変換できない場合
                  //予約基本情報取得レスポンス.予約日付区分の値に沿って、保持している検索条件.複雑旅程区間[1].出発日を設定する
                  if (
                    this.isEmpty(requestParam['departureDate1'] as string) ||
                    !this._searchFlightBodyContComponent.judgeStringDate(requestParam['departureDate1'] as string)
                  ) {
                    const departureDate2IsInvalid =
                      this.isEmpty(requestParam['departureDate2'] as string) ||
                      !this._searchFlightBodyContComponent.judgeStringDate(requestParam['departureDate2'] as string);

                    switch (responseBasic.data?.reservationDateDivision) {
                      case '00':
                        departureDate1.setDate(departureDate1.getDate());
                        if (departureDate2IsInvalid) {
                          departureDate2.setDate(departureDate2.getDate() + defaultAdditionalDaysToNextBound);
                        } else {
                          departureDate2 = this._searchFlightState.onewayOrMultiCity[1]?.departureDate;
                        }
                        break;
                      case '01':
                        departureDate1.setDate(departureDate1.getDate() + 1);
                        if (departureDate2IsInvalid) {
                          departureDate2.setDate(departureDate2.getDate() + 1 + defaultAdditionalDaysToNextBound);
                        } else {
                          departureDate2 = this._searchFlightState.onewayOrMultiCity[1]?.departureDate;
                        }
                        break;
                      case '07':
                        departureDate1.setDate(departureDate1.getDate() + 7);
                        if (departureDate2IsInvalid) {
                          departureDate2.setDate(departureDate2.getDate() + 7 + defaultAdditionalDaysToNextBound);
                        } else {
                          departureDate2 = this._searchFlightState.onewayOrMultiCity[1]?.departureDate;
                        }
                        break;
                      case '62':
                        departureDate1.setMonth(departureDate1.getMonth() + 2);
                        if (departureDate2IsInvalid) {
                          departureDate2.setMonth(departureDate2.getMonth() + 2);
                          departureDate2.setDate(departureDate2.getDate() + defaultAdditionalDaysToNextBound);
                        } else {
                          departureDate2 = this._searchFlightState.onewayOrMultiCity[1]?.departureDate;
                        }
                        break;

                      default:
                        departureDate1 = this._searchFlightState.onewayOrMultiCity[0].departureDate;
                        departureDate2 = this._searchFlightState.onewayOrMultiCity[1]?.departureDate;
                        break;
                    }
                  } else {
                    departureDate1 = this._searchFlightState.onewayOrMultiCity[0].departureDate;
                    departureDate2 = this._searchFlightState.onewayOrMultiCity[1]?.departureDate;
                  }
                  const bounds = this._searchFlightState.onewayOrMultiCity.map((bound, index) => {
                    if (index >= 2) return bound;
                    if (index == 1)
                      return {
                        ...bound,
                        originLocationCode: bound.originLocationCode || responseBasic.data?.arrivalLocationCode || null,
                        destinationLocationCode:
                          bound.destinationLocationCode || responseBasic.data?.departureLocationCode || null,
                        departureDate: departureDate2 || null,
                      };
                    if (index == 0)
                      return {
                        ...bound,
                        originLocationCode:
                          bound.originLocationCode || responseBasic.data?.departureLocationCode || null,
                        destinationLocationCode:
                          bound.destinationLocationCode || responseBasic.data?.arrivalLocationCode || null,
                        departureDate: departureDate1 || null,
                      };
                    return bound;
                  });
                  const oneOrMulticityState: SearchFlightState = {
                    ...this._searchFlightState,
                    onewayOrMultiCity: bounds,
                  };
                  this._searchFlightStoreService.updateStore(oneOrMulticityState);
                }
              }
            }
          }
        }
      );
    }
  }

  /** 空港コード用キャッシュ */
  public departureAirportList: Airport[] | undefined = undefined;
  public destinationAirportList: Airport[] | undefined = undefined;
  public transitAirportList: Airport[] | undefined = undefined;

  /** キャッシュから空港部品の照会用 IATA コードを取得する */
  private getForSearchAirportCode(code: string, type: string = 'origin') {
    let airports: Airport[] | undefined = [];
    if (type === 'origin') {
      airports = this.departureAirportList;
    } else if (type === 'destination') {
      airports = this.destinationAirportList;
    } else if (type === 'transit') {
      airports = this.transitAirportList;
    } else {
      airports = this.destinationAirportList;
    }
    const match = airports?.find((airport) => airport.airport_code === code) ?? null;
    const searchAirportCode = match?.search_for_airport_code ?? code;
    return searchAirportCode;
  }

  /** フライト検索画面再表示判定 */
  private isDisplayAgain(): boolean {
    const searchFlightConditionForRequestState = this._searchFlightConditionForRequestService.getData();
    const itineraries = searchFlightConditionForRequestState.request.itineraries;
    return itineraries.length > 0;
  }
  /** 空判定 */
  private isNotEmpty(value: any): boolean {
    return value !== '' && value !== null && value !== undefined;
  }
  /** 親のshowErrorMsgを子から呼び出す為の処理
   *  外部流入の場合のみ実施
   */
  public showErrorMsg(): void {
    const cont = this._searchFlightBodyContComponent;
    if (
      cont.searchFlightBodyPresComponent != null &&
      cont.searchFlightBodyPresComponent.roundTripComponent != null &&
      cont.requestParam != null
    ) {
      cont.showErrorMsg(cont.checkInputData(undefined, cont.requestParam));
    }
  }
}
